import React from "react";
import { useFormContext } from "react-hook-form";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { SelectOptionItem } from "components/FormInput";
import StyledFormSelect from "components/FormInput/FormSelect";

import { ReactComponent as AddIcon } from "assets/images/add-icon.svg";

import { IbanAccount } from "store/features/ibanAccountSlice";
import { newAccountOption } from "shared/functions/ibanQrHelpers";

import { styles } from "./styles";

interface AccountSelectProps {
  options: SelectOptionItem<IbanAccount>[];
  onSelectAccount: (account: IbanAccount) => void;
}

const AccountSelect: React.FC<AccountSelectProps> = (props) => {
  const { options, onSelectAccount } = props;

  const formContext = useFormContext();

  const iban = formContext.watch("iban");
  const bankName = formContext.watch("bankName");

  return (
    <StyledFormSelect<IbanAccount>
      testId="iban-account-select"
      title="Реквізити отримувача"
      name="ibanAccountUid"
      options={options}
      fullWidth
      onSelectItem={onSelectAccount}
      helperText={bankName && iban ? `${iban} (${bankName})` : ""}
      sx={{ "& .MuiFormHelperText-root": styles.helperText }}
      fixedFooterOption={newAccountOption}
      fixedFooterContent={
        <Stack direction="row" alignItems="center" sx={{ pt: 1, pb: 1 }}>
          <AddIcon />
          <Typography color="primary" sx={{ ml: 1 }}>
            Нові реквізити
          </Typography>
        </Stack>
      }
    />
  );
};

export default AccountSelect;
